export default __webpack_public_path__ + "static/media/poster2.13e78dd2.jpg";